@if (!lightMode()) {
  <lib-product-card-chips [chipLabels]="chipsLabelsKeys()" />
}
@if (hasPromotion() && hasDiscountedCost()) {
  <lib-product-card-price
    data-testid="product-price-discounted"
    [price]="product().monthly_cost"
    [discountedPrice]="discountedPrice()"
    [discountLabel]="'- ' + discountPercentage() + ' %'"
    [isNavProduct]="isNavProduct()"
  />
} @else {
  <lib-product-card-price
    data-testid="product-price"
    [isNavProduct]="isNavProduct()"
    [price]="product().monthly_cost"
  />
}
